import axios from './axios'

export const getRangeAgeScopes = () => axios.get('/range_age_scope')
